import { useTranslation } from 'react-i18next'
import { CommonAuthProcessProps } from '@models'
import { AuthenticationProvider, AuthStep } from '@enums'
import { Loading, Result } from '@components'
import { NotificationForm } from '@forms'
import {
  ONE_MOMENT,
  PROCESSING_SECURE_TRANSACTION
} from '@constants/translationsKeys'
import { getAuthenticationStatusString } from '@utils/authentication-helpers'
import { useAuthProcess } from '../../hooks'
import { SetupIframe } from './components'

const PowertranzAuth: React.FC<CommonAuthProcessProps> = ({
  showBrand,
  initialAuthentication
}) => {
  const { t } = useTranslation()
  const {
    isLoading,
    authStep,
    authentication,
    setupData,
    checkAuthenticationResult
  } = useAuthProcess({
    authProvider: AuthenticationProvider.POWERTRANZ,
    initialAuthentication,
    showBrand
  })

  const renderLoading = () => (
    <Loading
      showBrand={showBrand}
      message={t(ONE_MOMENT, { extra: '...' })}
      description={t(PROCESSING_SECURE_TRANSACTION, { extra: '...' })}
    />
  )

  const renderStepUp = () => (
    <SetupIframe
      setupResult={setupData}
      onComplete={checkAuthenticationResult}
    />
  )

  const renderNotification = () => (
    <>
      {renderLoading()}
      <NotificationForm
        status={getAuthenticationStatusString(authentication?.status)}
        message={authentication?.statusMsg!}
        authenticationId={authentication!.authenticationId}
        orderId={authentication!.orderId}
        orderAmount={authentication!.orderAmount}
        redirectUrl={authentication!.externalReturnUrl}
      />
    </>
  )

  const renderResult = () => (
    <Result
      authStatus={authentication?.status}
      showBrand={showBrand}
      message={authentication?.statusMsg ?? ''}
    />
  )

  if (isLoading) return renderLoading()

  const stepComponents: Partial<Record<AuthStep, () => JSX.Element>> = {
    [AuthStep.STEP_UP]: renderStepUp,
    [AuthStep.NOTIFICATION]: renderNotification,
    [AuthStep.RESULT]: renderResult
  }

  return stepComponents[authStep]?.() ?? renderLoading()
}

export default PowertranzAuth
